import Pipelines from "layouts/applications/pipelines/Pipelines";
import CrmData from "layouts/applications/CRM data/CrmData";
import Invoice from "layouts/applications/invoice";
import HowAmIProjected from "layouts/applications/how am i projected";
import ManageUsers from "layouts/applications/manage users";

import TableViewIcon from "@mui/icons-material/TableView";
import ViewWeekIcon from "@mui/icons-material/ViewWeek";
import BarChartIcon from "@mui/icons-material/BarChart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TableChartIcon from "@mui/icons-material/TableChart";
import TableRowsIcon from "@mui/icons-material/TableRows";
import SettingsIcon from "@mui/icons-material/Settings";
import FunctionsIcon from "@mui/icons-material/Functions";
import JoinLeftIcon from "@mui/icons-material/JoinLeft";
import GroupIcon from "@mui/icons-material/Group";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { CLIENT_ADMIN, CLIENT_USER, CRUXY_ADMIN, CRUXY_USER } from "common/names";
import PublicIcon from "@mui/icons-material/Public";
import { WHY, WHERE } from "common/constants";
import Where from "layouts/applications/where";
import Why from "layouts/applications/why";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Tables from "./layouts/applications/tables";
import { Matcher } from "./layouts/applications/matcher/Matcher";
import AllTables from "./layouts/applications/alltables";
import Upload from "./layouts/applications/upload";
import { MatcherProvider } from "./utils/MatcherProvider";
import Merger from "./layouts/applications/merger/Merger";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MatcherIngest from "./layouts/applications/matcher/components/MatcherIngest";
import HeightIcon from "@mui/icons-material/Height";
import Headroom from "./layouts/applications/headroom/HeadRoom";
import { HeadroomProvider } from "./layouts/applications/headroom/context/HeadRoomProvider";
const iconStyle = { width: "1.5rem", height: "1.5rem" };

const routes = [
  /*
    {
        type: "collapse",
        name: "Pipelines",
        key: "pipelines",
        route: "/pipelines",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],

        component: (key: string) => <Pipelines key={key} />,

        icon: (color: string) => <ViewWeekIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "CRM Data",
        key: "crm-tables",
        route: "/crm-tables",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],
        component: <CrmData />,
        icon: (color: string) => <TableViewIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Invoice Data",
        key: "invoice-table",
        route: "/invoice-table",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],
        component: (key: string) => <Invoice key={key} />,
        icon: (color: string) => <ReceiptIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Where Am I?",
        key: "where-am-i",
        route: "/where-am-i",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],
        component: <Where />,
        icon: (color: string) => <BarChartIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },

    {
        type: "collapse",
        name: "Why?",
        key: "why",
        route: "/why",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],
        component: <Why />,
        icon: (color: string) => <TableChartIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "How Am I Projected?",
        key: "expectation-reality",
        route: "/expectation-reality",
        availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER],
        component: <HowAmIProjected />,
        icon: (color: string) => <FunctionsIcon sx={{ ...iconStyle, color: color }} />,
        noCollapse: true,
    },
    */
  {
    type: "collapse",
    name: "Data ingest",
    key: "dataingest",
    route: "/dataingest",
    availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN],
    component: <Upload />,
    icon: (color: string) => <UploadFileIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Merger",
    key: "merger",
    route: "/merger",
    availableFor: [CRUXY_USER, CRUXY_ADMIN],
    component: <Merger />,
    icon: (color: string) => <TableChartIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Matcher",
    key: "matcher",
    route: "/matcher",
    availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN],
    component: (
      <MatcherProvider>
        <Matcher />
      </MatcherProvider>
    ),
    icon: (color: string) => <JoinLeftIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Processed data",
    key: "processeddata",
    route: "/processeddata",
    availableFor: [CRUXY_USER, CRUXY_ADMIN],
    component: <AllTables />,
    icon: (color: string) => <TableRowsIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Headroom",
    key: "headroom",
    route: "/headroom",
    availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN],

    component: (
      <HeadroomProvider>
        <Headroom />
      </HeadroomProvider>
    ),
    icon: (color: string) => <HeightIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Matcher ingest",
    key: "matcheringest",
    route: "/matcheringest",
    availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN],
    component: <MatcherIngest />,
    icon: (color: string) => <CloudUploadIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "My Tables",
    key: "tables",
    route: "/tables",
    availableFor: [CLIENT_ADMIN, CLIENT_USER],
    component: <Tables />,
    icon: (color: string) => <TableRowsIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-1", availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN, CLIENT_USER] },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    route: "/settings",
    availableFor: [CRUXY_ADMIN, CRUXY_USER, CLIENT_ADMIN],
    component: <ManageUsers />,
    icon: (color: string) => <SettingsIcon sx={{ ...iconStyle, color: color }} />,
    noCollapse: true,
  },
];

export default routes;
